/**************************************************
 * Nombre:       Formulario_Pedido_Envio
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import {
    AccountBalanceOutlined,
    BalanceOutlined,
    Flag,
    PointOfSaleOutlined,
    SignpostOutlined
} from "@mui/icons-material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {useState} from "react";
import IngresoDinero from "../../Modulo_formularios/Componentes/IngresoDinero";
import {formatoMonedaGraficas} from "../../Modulo_Graficas/Utilidades/formatoMonedaGraficas";
import {consultarPagoReferencia} from "../../Modulo_Pasarela_Pagos/Funciones/consultarPagoReferencia";


const Formulario_Pedido_Pago = ({...props}) => {
    const [cargando, setCargando] = useState(false)
    const [datos, setDatos] = useState({})
    const verificar = async () => {

        let referencia = props.props.getValues('referencia')
        setCargando(true)
        let dox = await consultarPagoReferencia(referencia)
        console.log(dox)
        setDatos(dox.data)
        setCargando(false)

    }


    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={6}>
                    <IngresoTexto Icono={Flag} nombre={'Num Pedido'} dato={'consecutivo'} editable={false} {...props} />
                </Grid>

                <Grid container size={6}>
                    <IngresoTexto Icono={SignpostOutlined} nombre={'Estado'} dato={'estado'} {...props}
                                  editable={false}/>
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={AccountBalanceOutlined} nombre={'Referencia de pago'}
                                  dato={'referenciaEpayco'} {...props}
                                  editable={false}/>
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={BalanceOutlined} nombre={'Nombre del Banco'} dato={'nombreBanco'} {...props}
                                  editable={false}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoDinero Icono={PointOfSaleOutlined} nombre={'Valor Pagado'} dato={'pagado'}
                                   {...props} editable={false}/>
                </Grid>

                <Grid container size={6}>
                    <IngresoTexto Icono={PointOfSaleOutlined} nombre={'# de aprobacion'} dato={'numeroAprobacion'}
                                  {...props} editable={false}/>
                </Grid>

                <Grid container size={6}>
                    {datos.x_response &&
                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 12}}
                            spacing={0}>

                            <Grid container size={{xs: 12, sm: 12, md: 12}}>
                                <Typography>{`Estado: ${datos.x_response}`}</Typography>
                            </Grid>


                            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: -0.5}}>
                                <Typography
                                    sx={{fontSize: 14}}>{`Valor Pagado: ${formatoMonedaGraficas(datos.x_amount_ok)}`}</Typography>
                            </Grid>


                        </Grid>
                    }
                </Grid>

                <Grid container size={6} justifyContent={'flex-end'}>
                    <Button
                        onClick={() => verificar()}
                        loading={cargando}
                        variant={'outlined'} startIcon={<BalanceOutlined/>}>Verificar</Button>
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Pedido_Pago